function tidyUp({ componentIds, componentProps, screenId, showPopup, popupId }) {
    const selectedProps = {}
    componentIds.forEach(id => (selectedProps[id] = componentProps[id]))

    const result = {},
        starts = showPopup
            ? `router.screens.${screenId}.popups.${popupId}.components.`
            : `router.screens.${screenId}.components.`,
        range = 15

    ;['left', 'top', 'width', 'height'].forEach(propName => {
        aggregateByNumericProp(selectedProps, propName, range).forEach(g => {
            g.ids.forEach(id => {
                result[`${starts}${id}.${propName}`] = g.average
                selectedProps[id][propName] = g.average
            })
        })
    })

    /**
     * Агрегирует компоненты в группы по числовому свойству 'propName' (например left, top ...) с разбросом в +- range
     *
     * @param {*} componentProps
     * @param {*} propName
     * @param {*} range
     */
    function aggregateByNumericProp(componentProps, propName, range) {
        const groups = []
        Object.keys(componentProps).forEach(id => {
            const val = componentProps[id][propName]
            let groupFound = false
            for (let i = 0; i < groups.length; i++) {
                if (Math.abs(groups[i].average - val) <= range) {
                    groups[i].ids.push(id)
                    groups[i].values.push(val)
                    groups[i].average = average(groups[i].values)
                    groupFound = true
                    break
                }
            }
            if (!groupFound) {
                groups.push({
                    ids: [id],
                    average: val,
                    values: [val],
                })
            }
        })
        return groups
    }

    function average(array) {
        return array.reduce((a, b) => a + b) / array.length
    }

    return result
}

export default {
    tidyUp,
}
